/**
 * Plugin: $wcConfirm
 *
 * Monta ConfirmDialog una sola vez en <body> y expone
 * Vue.prototype.$wcConfirm para usarlo desde cualquier componente.
 *
 * Nota: se usa $wcConfirm en vez de $confirm para evitar colisión
 * con PrimeVue ConfirmationService que también ocupa ese nombre.
 *
 * Uso:
 *   const ok = await this.$wcConfirm({
 *     title:       '¿Eliminar servicio?',
 *     message:     'Esta acción no se puede deshacer.',
 *     confirmText: 'Eliminar',
 *     cancelText:  'Cancelar',
 *     variant:     'danger',   // danger | warning | info | success
 *   })
 *   if (ok) { ... }
 */

import Vue from 'vue'
import ConfirmDialog from '@/components/Modals/ConfirmDialog.vue'

let _instance = null

function getInstance() {
  if (!_instance) {
    const ConfirmCtor = Vue.extend(ConfirmDialog)
    // Se monta FUERA del arbol de la app (Vue.extend + $mount), asi que hay que
    // inyectarle a mano la instancia de i18n (Vue.prototype.$language la expone en
    // main.js). Sin esto, this.$t revienta en el data()/open() de ConfirmDialog y
    // $wcConfirm falla en silencio -> los dialogos de confirmar/eliminar "no hacian nada".
    _instance = new ConfirmCtor({ i18n: Vue.prototype.$language }).$mount()
    document.body.appendChild(_instance.$el)
  }
  return _instance
}

const ConfirmPlugin = {
  install(Vue) {
    Vue.prototype.$wcConfirm = function (opts = {}) {
      return getInstance().open(opts)
    }

    /**
     * Aviso de UN botón, con la misma caja que las confirmaciones.
     *
     * Existe para dejar de usar SweetAlert en los resultados: su diálogo no es el de
     * este panel (círculo rojo, botón rojo, tipografía distinta) y cantaba justo en el
     * momento en que el anfitrión está pendiente de si su envío salió o no.
     *
     *   await this.$wcAlert({ title: 'Enviadas', message: '…', variant: 'success' })
     */
    Vue.prototype.$wcAlert = function (opts = {}) {
      return getInstance().open({
        variant: 'info',
        confirmText: 'Entendido',
        ...opts,
        cancelText: null,
      })
    }
  },
}

export default ConfirmPlugin
